import { makeStyles } from '@material-ui/core';

export const styles = theme => ({
  listContainer: {
    marginTop: 25
  },
});

export default makeStyles(styles);